import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Col, Modal, ModalBody, Row,Table } from "reactstrap"
import { format } from 'date-fns';
import  { Redirect } from 'react-router-dom'

class DetailModal extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      ok:"",

    }

    this.handleDetail.bind(this)
  }
  componentDidMount() {}

  handleDetail=(id)=>{
    sessionStorage.setItem('idEvenement',id);
    this.setState({ok: <Redirect to='/detail-evenement'  />});
  }

  render (){
  const show =this.props.show
  const onCloseClick=this.props.onCloseClick
  const event=this.props.event

  return (
    <Modal  isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5" style={{borderRadius:"25px"}}>
        {this.state.ok}
        
        <Row className="mb-3">
          <Col lg={4}>
            <div>
              <i  className="bx bx-calendar-event text-info display-5" style={{ lineHeight : '1'}}/>
            </div>
          </Col>
          <Col lg={4}></Col>
          <Col lg={4} className="pull-right" style={{textAlign:"right"}}> 
            <button
              type="button"
              className="btn btn-info btn-sm me-2"
              href="/detail-evenement"
              onClick={onCloseClick}
              style={{backgroundColor:"#6A7172"}}
            >
            Fermer
            </button> 
          </Col>
        </Row>

        <Row className="mb-3">
          <Col lg={12}>
            <Table responsive striped bordered hover>
              <thead>
                <tr>
                  {/* <th><strong> Libelle : </strong></th>
                  <th><strong> Lieu : </strong></th> */}
                </tr>
              </thead>
              <tbody>      
                <tr>
                  <td><strong> Libelle : </strong></td>
                  <td className="text-center"><span>{event.libelle}</span></td> 
                </tr>
                <tr>
                  <td><strong> Lieu : </strong></td> 
                  <td className="text-center"><span>{"  "+event.lieu}</span></td>
                </tr>
                <tr>
                  <td><strong> Cible : </strong></td> 
                  <td className="text-center"><span>{"  "+event.cible}</span></td> 
                </tr>
                <tr> 
                  <td><strong> Organisateur : </strong></td> 
                  <td className="text-center"><span>{"  "+event.organisateur}</span></td>
                </tr>
                <tr>
                  <td><strong> Date de début : </strong></td>
                  <td className="text-center"><span style={{backgroundColor:"#34c38f"}} class="badge rounded-pill ">{event.date_debut}</span> À <span style={{backgroundColor:"#34c38f"}} class="badge rounded-pill ">{" "}{" "+event.heure_debut}</span></td>
                </tr>
                <tr>
                  <td><strong> Date de fin : </strong></td> 
                  <td className="text-center"><span style={{backgroundColor:"#f1734f"}} class="badge rounded-pill ">{event.date_fin}</span> À <span style={{backgroundColor:"#f1734f"}} class="badge rounded-pill ">{" "}{" "+event.heure_fin}</span></td>
                </tr>
              </tbody>
            </Table>

             {/* <div className="mb-2"><strong> Libelle :      </strong> <span>{event.libelle}</span></div>
             <div className="mb-2"><strong> Lieu :         </strong><span>{"  "+event.lieu}</span></div>
             <div className="mb-2"><strong> Cible : </strong><span>{"  "+event.cible}</span></div>
             <div className="mb-2"><strong> Organisateur : </strong><span>{"  "+event.organisateur}</span></div>
             <div className="mb-2"><strong> Date de début : </strong><span style={{backgroundColor:"#34c38f"}} class="badge rounded-pill ">{event.date_debut}</span> À <span style={{backgroundColor:"#34c38f"}} class="badge rounded-pill ">{" "}{" "+event.heure_debut}</span></div>
             <div className="mb-2"><strong> Date de fin : </strong><span style={{backgroundColor:"#f1734f"}} class="badge rounded-pill ">{event.date_fin}</span> À <span style={{backgroundColor:"#f1734f"}} class="badge rounded-pill ">{" "}{" "+event.heure_fin}</span></div> */}

          </Col>
        </Row>

        <Row>
          <Col md="8"></Col>

          <Col md="4" className="pull-right">
            <div className="mt-3" style={{float:"right"}}>
              <button
                type="button"
                className="btn btn-info btn-sm me-2"
                href="/detail-evenement"
                onClick={this.handleDetail.bind(this.bind,event.id_event)}
                // style={{backgroundColor:"#338C36"}}
              >
                <i className="mdi mdi-plus-circle-outline me-1" />
                Voir plus
              </button>
            </div>
          </Col>
         
          {/* <Col md="5">
            <div className="mt-3" style={{float:"rigth"}}>
              
              <button
                type="button"
                className="btn btn-info btn-sm me-2"
                href="/detail-evenement"
                onClick={this.handleDetail.bind(this.bind,event.id_event)}
                // style={{backgroundColor:"#6A7172"}}
              >
                Modifier l'évenement
              </button>
            </div>
          </Col> */}
        </Row>
      </ModalBody>

    </Modal>
  )
}


  }
export default DetailModal
